import { Table } from "elemental-react16";
import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import Price from "../../../../components/Price/Price";

class OrderPreviewRow extends Component {
  render() {
    let { order, path } = this.props;
    const orderDate = moment( order.register )
      .format( "DD-MM-YYYY" )
    const orderLink = `${path}/${order.map_id}`
    const isSuccess = (order.status === 2)
    return (
      <tr>
        <td>
          <Link to={orderLink}>
            #{order.map_id} {order.comment ? `- ${order.comment}` : ""}
          </Link>
        </td>
        <td className="tr"><Price>{order.netto}</Price></td>
        <td className="tc">{order.positions.length}</td>
        <td className="tc">{orderDate}</td>
        <td className="tl f7">
          <div className="nowrap">{order.extras.name1}</div>
          <div className="nowrap">{order.extras.email}</div></td>
      </tr>
    )
  }
}

const OrderTable = ( { orders, path = "/account/orders" } ) => {
  if ( orders.length === 0 ) {
    return null
    // return (<p>Keine Bestellungen gefunden.</p>)
  }
  
  return (
    <div className="table-scroller">
      <Table>
        <colgroup>
          <col width="65%"/>
          <col width="10%"/>
          <col width="10%"/>
          <col width="10%"/>
          <col width="5%"/>
        </colgroup>
        
        <tbody>
        <tr>
          <th className="ttu">{translate( "order number" )}</th>
          <th className="ttu tr">{translate( "price" )}</th>
          <th className="ttu tc">{translate( "positions" )}</th>
          <th className="ttu tc">{translate( "Datum" )}</th>
          <th className="ttu tc">{translate( "Kontakt" )}</th>
        </tr>
        
        {orders.length > 0 && orders.map( ( order ) => <OrderPreviewRow path={path} key={order.id} order={order}/> )}
        </tbody>
      </Table>
    </div>
  )
}
export default OrderTable


// WEBPACK FOOTER //
// ./src/theme/orfix-test/components/OrderTable/OrderTableAccount.js